<loren-page-content>
  <mat-card-title>{{ "toolbar.roles" | transloco }}</mat-card-title>
  <div class="row mt-3">
    <div class="col">
      <button
        *lorenShowForPrivileges="[privileges.WRITE_ROLE]"
        mat-stroked-button
        color="primary"
        class="mb-3"
        (click)="handleCreate()">
        <mat-icon>add</mat-icon>{{ "roles.new" | transloco }}
      </button>
      @if(loading()) {
      <div class="m-3">
        <mat-spinner></mat-spinner>
      </div>
      } @else if (error()) {
      <p>{{ "error_page.general_error_message" | transloco }}</p>
      } @else {
      <mat-card>
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>{{ "operations.search_here" | transloco }}</mat-label>
          <input #userSearch matInput />
        </mat-form-field>
        <mat-selection-list
          hideSingleSelectionIndicator
          [multiple]="false"
          [(ngModel)]="selectionValue"
          (selectionChange)="handleEdit($any($event))">
          @for(role of roles(); track role) {
          <mat-list-option
            class="loren-role-item"
            [value]="role"
            [style.color]="role.readOnly ? '#3F51B5' : null">
            {{ role.name }}
          </mat-list-option>
          }
        </mat-selection-list>
      </mat-card>
      }
    </div>
  </div>
</loren-page-content>
